/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Descriptor, { IDescriptorBody } from './../../descriptor';

interface IBaseOperationMetadata {
	userId: string;
	type?: string;
}

export interface IOperationMetadata extends IBaseOperationMetadata {
	createdAt?: Date;
}

export interface IOperationMetadataJSON extends IBaseOperationMetadata {
	createdAt?: string;
}

export default class OperationMetadataDescriptor extends Descriptor {
	public static readonly DESCRIPTOR_NAME: string = 'OperationMetadataDescriptor';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			userId: {
				type: 'string',
				id: 1
			},
			type: {
				type: 'string',
				id: 2
			},
			createdAt: {
				type: 'string',
				id: 3
			}
		}
	} ) )();

	public static toJSON( { createdAt, ...metadata }: IOperationMetadata ): IOperationMetadataJSON {
		const parsedMetadata: IOperationMetadataJSON = { ...metadata };

		if ( createdAt?.toISOString ) {
			parsedMetadata.createdAt = createdAt.toISOString();
		}

		return parsedMetadata;
	}

	public static fromJSON( { createdAt, ...metadata }: IOperationMetadataJSON ): IOperationMetadata {
		const parsedMetadata: IOperationMetadata = { ...metadata };

		if ( createdAt ) {
			parsedMetadata.createdAt = new Date( createdAt );
		}

		return parsedMetadata;
	}
}
